const INITIAL_STATE = {
  qrCodeEan: '',
  qrCodeLotNumber: null,
  qrCodeExpirationDate: null,
  qrCodeManufacturingDate: null,
  qrCodeQuantity: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'qr_code_EAN':
      return {
        ...state,
        qrCodeEan: action.payload,
      };
    case 'qr_code_lot_number':
      return {
        ...state,
        qrCodeLotNumber: action.payload,
      };
    case 'qr_code_expiration_date':
      return {
        ...state,
        qrCodeExpirationDate: action.payload,
      };
    case 'qr_code_manufacturing_date':
      return {
        ...state,
        qrCodeManufacturingDate: action.payload,
      };
    case 'qr_code_quantity':
      return {
        ...state,
        qrCodeQuantity: action.payload,
      };
    case 'qr_code_initial_props':
      return {
        ...state,
        qrCodeEan: '',
        qrCodeLotNumber: null,
        qrCodeExpirationDate: null,
        qrCodeManufacturingDate: null,
        qrCodeQuantity: null,
      };
    default:
      return state;
  }
};
